import React from 'react';
import { Box, Dialog } from '@mui/material';

export default function ScheduleSurface({
  mobile,
  open,
  onClose,
  children,
}: {
  mobile: boolean;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) {
  if (!open) return null;
  return mobile ? (
    <Box sx={{ minWidth: 0, pb: 1 }}>{children}</Box>
  ) : (
    <Dialog open onClose={onClose} maxWidth='xl'>
      {children}
    </Dialog>
  );
}
